import { useState, useEffect } from 'react';
import { useTwilioAppState } from '../state/';

export default function useIsTrackEnabled(track) {
  const [isEnabled, setIsEnabled] = useState(track ? track.isEnabled : false);
  const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {
            setIsEnabled(track ? track.isEnabled : false);
            if (track) {
                const setEnabled = () => setIsEnabled(true);
                const setDisabled = () => setIsEnabled(false);
                track.on('enabled', setEnabled);
                track.on('disabled', setDisabled);
                return () => {
                    track.off('enabled', setEnabled);
                    track.off('disabled', setDisabled);
                };
            }
        }
    }, [track, _isMounted]);

  return isEnabled;
}
